import {combineReducers} from 'redux';
import {reducer as reduxFormReducer} from 'redux-form';
import auth from './auth';
import consultPackages from './consult-packages';
import errors from './errors';
import examReports from './exam-reports';
import homeworks from './homeworks';
import studentCourse from './student-course';
import reports from './reports';
import reportsData from './reports-data';
import student from './student';
import user from './user';
import studentCourses from './student-courses';
import remainStudentCourses from './remain-student-courses';
import studentProgressData from './student-progress-data';
import studentCoursesDurationData from './student-courses-duration-data';
import studentType from './student-type';
import studentTypes from './student-types';
import voices from './voices';
import {LOGOUT} from '../constants/auth';

const appReducer = combineReducers({
  form: reduxFormReducer,
  errors,
  auth,
  user,
  student,
  studentCourse,
  reports,
  reportsData,
  homeworks,
  examReports,
  studentCourses,
  remainStudentCourses,
  studentProgressData,
  studentCoursesDurationData,
  consultPackages,
  voices,
  studentType,
  studentTypes,
});

function rootReducer(state, action) {
  if (action.type === LOGOUT) state = undefined;
  return appReducer(state, action);
}

export default rootReducer;
